/**
 * Converts a string to proper title case, with special handling for
 * common law enforcement abbreviations and words.
 */
const LOWERCASE_WORDS = new Set([
  'a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'on', 'at',
  'to', 'by', 'in', 'of', 'up', 'as', 'is', 'it',
]);

const ALWAYS_UPPERCASE = new Set([
  'pd', 'so', 'da', 'doj', 'fbi', 'dea', 'atf', 'cia', 'nsa',
  'swat', 'k9', 'usa', 'us', 'cjis', 'ncic', 'leo',
]);

export function toTitleCase(str) {
  if (!str) return '';
  return str
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) => {
      const clean = word.replace(/[^a-z0-9]/gi, '').toLowerCase();
      if (ALWAYS_UPPERCASE.has(clean)) return word.toUpperCase();
      if (index !== 0 && LOWERCASE_WORDS.has(clean)) return word.toLowerCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}
